import React,  { Component } from 'react';
import { Link } from 'react-router';
import { AccountInfo } from '../../components';
import Particles from '../particles/particles';


class Navigation extends Component {
  render() {
    return (
      <div>
        <Particles />
        <div className="navigation">
          <div className="nav-logo">
            <i className="fab fa-ethereum"></i>
            <Link className="no-underline" to="/">Ether DNS</Link>
          </div>
          <ul>
            <li><Link to="/find">Search</Link></li>
            <li><Link to="/set">Set</Link></li>
            <li><Link to="/market">Market</Link></li>
          </ul>
          <AccountInfo />
        </div>
        <div className="content">{this.props.children}</div>
      </div>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/layouts/navigation/Navigation.js